/* eslint-disable */
import React, { useEffect, useRef, useState } from "react";
import BossDialog from "../../components/BossDialog";
import { Form, FormElement } from "@progress/kendo-react-form";
import * as API from "../../framework/API/api"
import { BUCKET_CONFIG_TYPE, ENTITYNAME, LOGEVENT, MODULE, OFFER_TYPE, RIS_TYPE, VODTYPE } from "../../framework/constant/constant";
import { DropDownList } from "@progress/kendo-react-dropdowns";
import { EditPageHeader } from "../../components/EditPageHeader";
import { toast } from 'react-toastify';
import { useTranslation } from "../../locale/useTranslation";
import { utility } from "../../framework/utility/utilityProvider";
import { Description, Title } from "@mui/icons-material";


export const CatalogueEditForm = (props) => {
  const lang = useTranslation();
  const blankDataItem = {
    ...props.item,
    SID: props.item.SID ?? 0,
    Description: props.item.copy ? 'copy of ' + props.item.Description : props.item.Description ?? '',
    Archive: props.item.Archive ?? false,
  }

  const [dataItem, setDataItem] = useState(blankDataItem);
  useEffect(() => {
  }, [])


  //function to check the validation in form
  const isValid = () => {
        if (!dataItem.Description || dataItem.Description == "") {
      toast.error(`${lang.please_enter_description_error_message}`, {
        position: toast.POSITION.TOP_RIGHT
      });
      return false;
    }

    return true;
  }

  const handleSubmit = async (e) => {

    if (!isValid()) return;
    const saveData = {
      _id: dataItem._id,
      SID: dataItem.SID ?? 0,
      Description: dataItem.Description,
      Archive: dataItem.Archive ?? false,
    }
    console.log(saveData);

    let res = await API.saveData(ENTITYNAME.Catalogues, saveData);
    if (res.success) {
      let logData = { event: res.message == "updated" ? LOGEVENT.UPDATE : LOGEVENT.INSERT, module: MODULE.CATALOGUES, data: res.data, message: res.message };
      API.SaveLogs(logData);
      utility.deleteLocalStorageItem(ENTITYNAME.Catalogues);
      props.cancelEdit();
      props.refresh();
    }
    else {
      toast.error(res.message, {
        position: toast.POSITION.TOP_RIGHT
      });
    }
  }

  const onChangeForm = (e) => {
    if (e.target.name == "Archive") {
      setDataItem({ ...dataItem, Archive: !dataItem.Archive });
    } else {
      setDataItem({ ...dataItem, [e.target.name]: e.target.value });
    }

  }

  return (
    <BossDialog
      title={props.item.SID > 0 ? props.item.Description : "Create Catalogue"}
      onClose={props.cancelEdit}
      width={"420px"}
    >
      <EditPageHeader title={""} onSubmit={handleSubmit} onCancel={props.cancelEdit} showTitle={false} />
      <div className="row mt-2 form-group">
        <div className="col">
          <label>{lang.description_label} *</label>
          <input
            name={"Description"}
            type="text"
            className="form-control form-control-sm"
            onChange={onChangeForm}
            value={dataItem.Description}
          />
        </div>
      </div>
      <div className="row form-group">
        <div className="col" >
          <input type={"checkbox"} name={"Archive"}
            onChange={(e) => onChangeForm(e)}
            value={dataItem.Archive}
            checked={dataItem.Archive} />
          <label className="ml-1">{lang.archive}</label>
        </div>

      </div>
    </BossDialog>)
};